/* eslint-env es6 */

import UAParser from 'ua-parser-js';

const ua_extensions = {
    browser: [
        [
            / (IRCCloud)\/([\w\.-]+) Chrome/i
        ], [[UAParser.BROWSER.NAME, 'IRCCloud Electron'], UAParser.BROWSER.VERSION],
        [
            // IRCCloud/4.28 (Mac; en-US; iPadOS 18.1)
            // /^(IRCCloud)\/([\w\.-]+) \(Mac; /i
            /^(IRCCloud)\/([\w\.-]+) \(Mac; [^;]+; iPadOS [\w\.]+/i
        ], [[UAParser.BROWSER.NAME, 'IRCCloud Silicon'], UAParser.BROWSER.VERSION],
        [
            /^(IRCCloud)\/([\w\.-]+)/i
        ], [[UAParser.BROWSER.NAME, 'IRCCloud Mobile'], UAParser.BROWSER.VERSION],
        [
            /^irccloudapi\/[\w\.-]+ (prattle)\/([\w\.-]+)/i
        ], [UAParser.BROWSER.NAME, UAParser.BROWSER.VERSION]
    ],
    engine: [
        [
            / IRCCloud\/[\w\.-]+ Chrome\/[\w\.-]+ (Electron)\/([\w\.-]+)/i
        ], [UAParser.ENGINE.NAME, UAParser.ENGINE.VERSION],
        [
            /^(irccloudapi)\/([\w\.-]+) prattle\/[\w\.-]+/i
        ], [UAParser.ENGINE.NAME, UAParser.ENGINE.VERSION]
    ],
    device: [
        [
            /^IRCCloud\/[\w\.-]+ \(([^;]+); [a-z]{2,2}; Android /i
        ], [UAParser.DEVICE.MODEL, [UAParser.DEVICE.TYPE, 'mobile']]
    ],
    os: [
        [
            /^IRCCloud\/[\w\.-]+ \(Mac; [^;]+; (iPadOS) ([\w\.]+)/i
        ], [[UAParser.OS.NAME, 'Mac iPadOS'], UAParser.OS.VERSION],
        [
            /^IRCCloud\/[\w\.-]+ \(i(?:(?:phone)|(?:pad)|(?:pod touch)); [^;]+; ((?:ios)|(?:ipados)) ([\w\.]+)/i
        ], [[UAParser.OS.NAME, 'iOS'], UAParser.OS.VERSION],
        [
            /^irccloudapi\/[\w\.-]+ (prattle)\/([\w\.-]+)/i
        ], [UAParser.OS.NAME, UAParser.OS.VERSION]
    ]
};
const ua_parser = new UAParser(ua_extensions);

export function parse (ua) {
    return ua_parser.setUA(ua).getResult();
}

export function icons (ua) {
    let icons = [];
    let result = parse(ua);

    let osIcon = '';
    switch (result.os.name) {
    case 'Mac OS':
    case 'iOS':
    case 'Mac iPadOS':
        osIcon = 'fa-apple';
        break;
    case 'Windows':
        osIcon = 'fa-windows';
        break;
    case 'Android':
        osIcon = 'fa-android';
        break;
    case 'Linux':
        osIcon = 'fa-linux';
        break;
    }

    if (osIcon) {
        icons.push($('<i>').addClass('fa ' + osIcon));
    }

    let browserIcon = '';
    switch (result.browser.name) {
    case 'Chrome':
        browserIcon = 'fa-chrome';
        break;
    case 'Firefox':
        browserIcon = 'fa-firefox';
        break;
    case 'Safari':
        browserIcon = 'fa-safari';
        break;
    case 'IE':
        browserIcon = 'fa-internet-explorer';
        break;
    case 'IRCCloud Electron':
        browserIcon = 'fa-desktop';
        break;
    case 'IRCCloud Mobile':
        browserIcon = 'fa-mobile-phone';
        break;
    }
    if (browserIcon) {
        icons.push($('<i>').addClass('fa ' + browserIcon));
    }

    return icons;
}



// WEBPACK FOOTER //
// ./app/src/lib/ua.es6